import "./header.scss";

import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { DEFAULT_AGENCY_CODE } from "src/config";
import i18n, { LowerLanguage, lowerLanguage } from "src/i18n";
import { NotLandingPaths, Paths } from "src/navigation";
import { atomCurrentStep, atomIsGroup, selectorAgency } from "src/storage";
import { useBoolean } from "src/utils";
import { useResponsiveBp } from "src/utils/hook-functions/responsive-bp.hook";

export const useHeader = () => {
  const navigate = useNavigate();

  const agency = useRecoilValue(selectorAgency);
  const [radioLanguage, setRadioLanguage] = useState(lowerLanguage);

  const goToLanding = () => {
    const agencyCode =
      agency && agency?.id !== DEFAULT_AGENCY_CODE ? agency?.id : "";
    navigate(Paths.Landing + "?" + agencyCode);
  };

  /**
   * Languages
   */
  const [showLanguagesMenu, , closeLanguagesMenu, toggleShowLanguagesMenu] =
    useBoolean(false);

  const languages: LowerLanguage[] = ["it"]; //"en", "de"];
  const onChangeLanguage = (language: LowerLanguage) => {
    setRadioLanguage(language);
    i18n.changeLanguage(language);
    setTimeout(() => window.location.reload());
  };
  const handleChangeLanguage = (lang: LowerLanguage) => {
    onChangeLanguage(lang);
    toggleShowLanguagesMenu();
  };

  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        closeLanguagesMenu();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const { pathname } = useLocation();
  const isNotLanding =
    NotLandingPaths.includes(pathname) && pathname !== Paths.Faqs;

  const { isDesktop } = useResponsiveBp();
  const currentStep = useRecoilValue(atomCurrentStep);
  const isGroup = useRecoilValue(atomIsGroup);
  const noShadhow = useMemo(
    () =>
      !isDesktop &&
      (isGroup
        ? currentStep === 3 || currentStep === 4
        : currentStep === 2 || currentStep === 3),
    [isGroup, currentStep, isDesktop]
  );

  return {
    dropdownRef,
    languages,
    showLanguagesMenu,
    noShadhow,
    isNotLanding,
    toggleShowLanguagesMenu,
    handleChangeLanguage,
    goToLanding,
  };
};
